import React from 'react';
import DropdownBase from '../DropdownBase';
const base = function () {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'entities';
  return "".concat(process.env.REACT_APP_BASE_URL, "/").concat(type).concat(process.env.REACT_APP_URL_ENV, "/");
};
const name = 'Credit';
const items = [{
  link: "".concat(base('contracts'), "truck_orders_on_hold"),
  label: 'Credit Holds'
}, {
  link: "".concat(base(), "customers"),
  label: 'Customers'
}, {
  link: "".concat(base('contracts'), "invoices"),
  label: 'Invoices'
}, {
  submenu: true,
  menu: /*#__PURE__*/React.createElement(DropdownBase, {
    submenu: true,
    name: "Maintenance",
    items: [{
      link: "".concat(base(), "counterparty_types"),
      label: 'Counterparty Types'
    }, {
      link: "".concat(base(), "country_risk_ratings"),
      label: 'Country Risk Rating'
    }, {
      link: "".concat(base(), "customer_credit_hold_exclusions"),
      label: 'Credit Hold Exclusions'
    }, {
      link: "".concat(base(), "credit_locations"),
      label: 'Credit Locations'
    }, {
      link: "".concat(base(), "credit_statuses"),
      label: 'Credit Statuses'
    }, {
      link: "".concat(base(), "terms"),
      label: 'Credit Terms'
    }, {
      link: "".concat(base(), "hold_reasons"),
      label: 'Hold Reasons'
    }, {
      link: "".concat(base(), "credit_ratings"),
      label: 'Credit Ratings'
    }, {
      link: "".concat(base(), "credit_reference_types"),
      label: 'Reference Types'
    }, {
      link: "".concat(base(), "credit_sectors"),
      label: 'Sectors/ Industries'
    }, {
      link: "".concat(base(), "volume_measurements"),
      label: 'Volume Measurement'
    }]
  })
}];
const Credit = () => /*#__PURE__*/React.createElement(DropdownBase, {
  name: name,
  items: items
});
export default Credit;